import React from 'react';
import { FLAG_KINDS, flagKind } from './flagKinds';
import { flagLastDay } from './profileFacts';
import './Chips.css';

/**
 * A customer's flags in force, the blocking one first:
 *   - FlagChips ("⚑ Do Not Service"): beside the name on the profile, the
 *     quick view, list rows, search results and the order page. `flags` are
 *     the flags themselves (reason and end day show on hover) or just their
 *     kinds (a list row's). With `onOpen(flag)` each chip is a button (a
 *     manager changes the flag).
 *   - FlagList: each flag with its reason, end day and who set it — the order
 *     page's customer card and New Order.
 */

const rank = (kind) => {
  const i = FLAG_KINDS.findIndex((k) => k.kind === kind);
  return i < 0 ? FLAG_KINDS.length : i;
};
const inOrder = (flags) => (flags || [])
  .map((f) => (typeof f === 'string' ? { kind: f } : f))
  .sort((a, b) => rank(a.kind) - rank(b.kind));

export function FlagList({ flags }) {
  const shown = inOrder(flags);
  if (!shown.length) return null;
  return (
    <ul className="cp-flag-list" aria-label="Customer flags">
      {shown.map((f) => {
        const k = flagKind(f.kind);
        const detail = [f.reason, f.ends_at && `until ${flagLastDay(f.ends_at)}`, f.set_by_name].filter(Boolean).join(' · ');
        return (
          <li key={f.id || f.kind} className={`cp-flag-line cp-flag-line--${k.tone}`}>
            <b>⚑ {k.label}</b>
            {detail && <span> {detail}</span>}
          </li>
        );
      })}
    </ul>
  );
}

const hover = (f, k) => [
  f.reason || k.hint,
  f.ends_at && `Until ${flagLastDay(f.ends_at)}`,
].filter(Boolean).join(' · ');

export default function FlagChips({ flags, onOpen, className = 'cp-flag-chips' }) {
  const shown = inOrder(flags);
  if (!shown.length) return null;
  return (
    <span className={className}>
      {shown.map((f) => {
        const k = flagKind(f.kind);
        const key = f.id || f.kind;
        return onOpen ? (
          <button key={key} type="button" className={`cp-chip cp-chip--${k.tone}`} onClick={() => onOpen(f)} title="Change or clear the flag">⚑ {k.label}</button>
        ) : (
          <span key={key} className={`cp-chip cp-chip--${k.tone}`} title={hover(f, k)}>⚑ {k.label}</span>
        );
      })}
    </span>
  );
}
